export const ObjectSharingConstants = {
	EMAIL_USER_LIMIT: 500
};
